import React, { useEffect, useState } from 'react';
import {
  itemState,
  statusLabel,
  summaryText,
  reasonLabel,
  recommendationSuggestion,
} from '../lib/evaluationIntegrity';

// #Fase1-2 — Controles comunes para conservar las reglas entre captura y revisión.
export function IntegrityFields({
  criterion,
  item = {},
  onChange,
  allowNA = false,
  recommendation = false,
  editRecommendation = true,
  clientView = false,
}) {
  const info = criterion.question_type === 'info';
  const suggestion = recommendationSuggestion(criterion, item);
  const [reason, setReason] = useState(item.na_reason || '');
  useEffect(() => {
    setReason(item.na_reason || '');
  }, [item.na_reason]);
  const canEditRecommendation = !!onChange && editRecommendation;
  const state =
    !onChange && item.status
      ? { status: item.status, missing: item.missing || [] }
      : itemState(criterion, item);
  return (
    <div className="space-y-2 my-3">
      {!clientView && (
        <span className="rounded bg-slate-100 text-slate-700 text-xs px-2 py-1">
          {statusLabel(state)}
        </span>
      )}
      {criterion.code && <span className="ml-2 text-xs font-bold">{criterion.code}</span>}
      {!info && allowNA && criterion.allow_na !== false && (
        <button
          type="button"
          className="soem-btn-secondary px-3 py-1 text-xs ml-2"
          onClick={() => onChange({ not_applicable: !item.not_applicable, na_reason: '' })}
        >
          {item.not_applicable ? 'Quitar No aplica' : 'No aplica'}
        </button>
      )}
      {item.not_applicable && (
        <div className="bg-blue-50 border border-blue-200 p-3 rounded-sm text-sm">
          <b>No aplica</b>
          {allowNA ? (
            <input
              aria-label="Motivo opcional de No aplica"
              className="w-full border rounded-sm p-2 mt-2"
              placeholder="Motivo opcional"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              onBlur={() => {
                if (reason !== (item.na_reason || '')) onChange({ na_reason: reason });
              }}
            />
          ) : (
            <p>{item.na_reason || 'Sin motivo indicado'}</p>
          )}
        </div>
      )}
      {!info && recommendation && (
        <label className="block text-xs text-slate-600">
          Recomendación
          <textarea
            className="w-full border rounded-sm p-2 text-sm"
            value={item.recommendation ?? ''}
            placeholder={canEditRecommendation ? suggestion : ''}
            onChange={
              canEditRecommendation
                ? (e) => onChange({ recommendation: e.target.value })
                : undefined
            }
            readOnly={!canEditRecommendation}
          />
          {canEditRecommendation && !item.recommendation && suggestion && (
            <button
              type="button"
              className="soem-btn-secondary text-xs p-2"
              onClick={() => onChange({ recommendation: suggestion })}
            >
              Usar recomendación sugerida
            </button>
          )}
        </label>
      )}
    </div>
  );
}

export function ScoreSummary({ evaluation }) {
  return <div className="text-xs text-slate-500 my-2"><p>{summaryText(evaluation)}</p>
    {evaluation?.score_summary?.informative_na_count != null && <p>
      Informativos en No aplica: {evaluation.score_summary.informative_na_count}
    </p>}
  </div>;
}

export function MissingList({ missing = [] }) {
  if (!missing.length) return null;
  return (
    <div role="alert" className="bg-red-50 border border-red-200 p-3 text-sm text-red-800">
      <p className="font-bold">Pendientes para enviar o publicar</p>
      <ul className="list-disc pl-5">
        {missing.map((m, i) => (
          <li key={`${m.question_id}-${i}`}>
            {m.code ? `${m.code} · ` : ''}
            {m.title}: {reasonLabel(m.reason)}
          </li>
        ))}
      </ul>
    </div>
  );
}
